import { BookMarked, Play, Plus } from "lucide-react";
import { useRef, useState } from "react";
import MenuIconTooltip from "./MenuIconTooltip";
import { MENU_LIBRARY_TOOLTIPS } from "../constants/menuTooltips";

const FILTER_SLOT_COUNT = 7;

export default function LibraryImportNav({
  visible = false,
  onImport = null,
  highlightsOpen = false,
  onToggleHighlights = () => {},
  resumeBook = null,
  onResume = () => {},
}) {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);
  if (!visible) return null;

  const chooseFile = () => {
    if (!busy) inputRef.current?.click();
  };

  return (
    <div className="menuFilterContainer library-import-nav">
      <MenuIconTooltip
        tooltip={MENU_LIBRARY_TOOLTIPS.import}
        placement="left"
        portal
        className="icon"
      >
        <Plus
          size={50}
          color="#39210d"
          strokeWidth={1}
          aria-label={MENU_LIBRARY_TOOLTIPS.import}
          style={{ cursor: busy ? "progress" : "pointer" }}
          onClick={chooseFile}
        />
      </MenuIconTooltip>
      <input
        ref={inputRef}
        type="file"
        accept=".epub,application/epub+zip"
        className="library-import-nav__input"
        aria-hidden="true"
        tabIndex={-1}
        onChange={(event) => {
          const file = event.target.files?.[0];
          event.target.value = "";
          if (!file || !onImport) return;
          setBusy(true);
          Promise.resolve(onImport(file)).finally(() => setBusy(false));
        }}
      />
      <MenuIconTooltip
        tooltip={MENU_LIBRARY_TOOLTIPS.highlights}
        placement="left"
        portal
        className={highlightsOpen ? "icon active" : "icon"}
      >
        <BookMarked
          size={50}
          color="#39210d"
          strokeWidth={1}
          aria-label={MENU_LIBRARY_TOOLTIPS.highlights}
          aria-pressed={highlightsOpen}
          style={{ cursor: "pointer" }}
          onClick={onToggleHighlights}
        />
      </MenuIconTooltip>
      <MenuIconTooltip
        tooltip={
          resumeBook?.id ? (
            <>
              <span className="vocab-tooltip-line">{MENU_LIBRARY_TOOLTIPS.resume}</span>
              <span className="vocab-tooltip-line">{resumeBook.title}</span>
            </>
          ) : (
            "Aucun roman en cours"
          )
        }
        placement="left"
        portal
        className="icon"
      >
        <Play
          size={50}
          color="#39210d"
          strokeWidth={1}
          aria-label={
            resumeBook?.id
              ? `${MENU_LIBRARY_TOOLTIPS.resume} : ${resumeBook.title}`
              : MENU_LIBRARY_TOOLTIPS.resume
          }
          aria-disabled={!resumeBook?.id}
          style={{ cursor: resumeBook?.id ? "pointer" : "default" }}
          onClick={() => {
            if (resumeBook?.id) onResume(resumeBook.id);
          }}
        />
      </MenuIconTooltip>
      {Array.from({ length: FILTER_SLOT_COUNT - 3 }, (_, index) => (
        <div key={index} className="library-import-nav__spacer" aria-hidden="true" />
      ))}
    </div>
  );
}
